/** THE IN AND OUT MARKS (ported 2026-10-18 from the medrec console's components/timeline/InOutBadge.tsx, its design plan's Lane 1; Rod's
 *  10-17 pick 2a there: "green ⬆ for what went OUT from us, blue ⬇ for what came IN, each with a direction word too"; DESIGN_SYSTEM 5). A
 *  22 px round badge with a DRAWN arrow (never the arrow emoji, which renders blue on Apple and grey on Windows and so cannot carry green),
 *  plus the direction word in 12 px semibold: Out in green, In in blue, "Draft, not sent" in grey (a green up arrow: it will go out); money a
 *  grey $, expected a dashed ring, any other event a grey dot, none of those with a word. The badge's hover says it too. In Sweet Claims:
 *  an AI call, a person's call and a letter went out; a claim number came in; the rest (a record added, the system's own step, a hold for a
 *  person) is an event. */
export type InOutKind = 'out' | 'in' | 'draft' | 'money' | 'expected' | 'event';
export const IN_OUT_WORDS: Readonly<Record<InOutKind, { word: string | null; title: string }>> = Object.freeze({
  out: { word: 'Out', title: 'Went out from us' },
  in: { word: 'In', title: 'Came in to us' },
  draft: { word: 'Draft, not sent', title: 'Our draft, not sent yet' },
  money: { word: null, title: 'Money' },
  expected: { word: null, title: 'Expected, not here yet' },
  event: { word: null, title: 'Something happened' },
});

export function InOutBadge({ kind, word = true }: { kind: InOutKind; word?: boolean }) {
  const w = IN_OUT_WORDS[kind];
  return (
    <span className={`tl-io-wrap tl-${kind}`} data-testid="in-out" data-kind={kind}>
      <span className={`tl-io tl-io-${kind}`} title={w.title} role="img" aria-label={w.title}>
        {kind === 'out' || kind === 'draft' ? (
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7" /></svg>
        ) : kind === 'in' ? (
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M19 12l-7 7-7-7" /></svg>
        ) : kind === 'money' ? (
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v18M16.5 7.5c0-1.7-2-3-4.5-3s-4.5 1.3-4.5 3 2 2.6 4.5 3 4.5 1.3 4.5 3-2 3-4.5 3-4.5-1.3-4.5-3" /></svg>
        ) : kind === 'event' ? <span className="tl-dot" aria-hidden="true" /> : null}
      </span>
      {word && w.word !== null ? <span className={`tl-dir tl-dir-${kind}`} aria-hidden="true">{w.word}</span> : null}
    </span>
  );
}
